
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/assistant/contacts",
      function () {
        return require("private-next-pages/assistant/contacts/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/assistant/contacts"])
      });
    }
  